import { render, staticRenderFns } from "./savings_subscribe.vue?vue&type=template&id=4f080e8e&scoped=true"
import script from "./savings_subscribe.vue?vue&type=script&lang=js"
export * from "./savings_subscribe.vue?vue&type=script&lang=js"
import style0 from "./savings_subscribe.vue?vue&type=style&index=0&id=4f080e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f080e8e",
  null
  
)

export default component.exports